import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DeduccionesIIGG } from '../../../../models/deducciones-IIGG';
import { ConfigDataService } from '../../../../services/config-data.service';
import { CodigosNominaService } from '../../../../services/codigosNomina.service';
import { MyValidations } from '../../../../utils/my-validations';
import { MomentSetService } from '../../../../core/services/moment-set.service';

@Component({
  selector: 'app-deduciones-iigg-detalle',
  templateUrl: './deduciones-iigg-detalle.component.html',
  styleUrls: ['./deduciones-iigg-detalle.component.css']
})
export class DeducionesIiggDetalleComponent implements OnInit, AfterViewInit {

  constructor(private configDataSrv: ConfigDataService,
              private codigosNominaService: CodigosNominaService,
              private fb: FormBuilder,
              private momentService: MomentSetService) { }

  @Input() set deduccion(deduccionRecibida: DeduccionesIIGG)
  {
    this.deduccionIIGGForm = deduccionRecibida;
    this.setearForm(deduccionRecibida);
  }

  @Input() set enabledForm(condition: boolean)
  {
    this.habilitarForm(condition);
  }

  @Input() MensajeError: string;
  @Input() verDetalle: boolean;
  @Input() disabledEditing: boolean;
  @Input() desdeAnterior: boolean;
  @Input() ingreso: any;
  @Input() anteriorRetroactividad: boolean;
  @Input() grupoLiq: any;
  @Input() deduccionesInvalida: boolean;

  form: FormGroup;
  deduccionIIGGForm: DeduccionesIIGG;
  actualizarFormatoInputNumerico = false;
  submitted: boolean;
  monedasList: any;
  clasesDocList: any;
  codigosNominaList: any;
  NominaList: any
  tipoCarga: number;
  formHabilitado: boolean;
  MensajeRetro = "";

  ngOnInit(): void
  {
    this.tipoCarga = 0;
    
    this.configDataSrv.getDatosDeducciones()
      .subscribe(
        data => {
          this.monedasList=data["Monedas"];
          this.clasesDocList=data["ClaseDocumentos"];
        },
        error => {
          console.log(error);
        });
    
    this.codigosNominaService.getAll().subscribe(
      codigos => 
      { 
        codigos.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
        });
        
        this.NominaList = codigos;
        this.cargaConceptos();
      });
    
    this.configurarValidadores();
    this.setearForm(this.deduccionIIGGForm);
  }

  configurarValidadores(): void
  {
    this.form = this.fb.group({
      id: ['', Validators.required],
      personal: ['', Validators.required],
      desde: ['', Validators.required],
      hasta: ['', [Validators.required, MyValidations.fecHastaMenor]],
      codigoNomina: ['', Validators.required],
      personaJuridica: ['', Validators.required],
      claseDocumento: ['', Validators.required],
      docNro: ['', Validators.required],
      cantidad: [''],
      importe: [''],
      moneda: ['']
    });

  }

  get registerFormControl()
  {
    return this.form.controls;
  }

  setearForm(deduccion: DeduccionesIIGG)
  {
    if (this.form != undefined)
    {
      this.form.controls['id'].setValue(deduccion?.id);
      this.form.controls['desde'].setValue(new Date(deduccion?.desde));
      this.form.controls['hasta'].setValue(new Date(deduccion?.hasta));
      this.form.controls['personal'].setValue(deduccion?.personal);
      this.form.controls['personaJuridica'].setValue(deduccion?.personaJuridica);
      this.form.controls['claseDocumento'].setValue(deduccion?.claseDocumento);
      this.form.controls['docNro'].setValue(deduccion?.docNro);
      this.form.controls['codigoNomina'].setValue(deduccion?.codigoNomina);
      this.form.controls['cantidad'].setValue(deduccion?.cantidad);
      this.form.controls['importe'].setValue(deduccion?.importe);
      this.form.controls['moneda'].setValue(deduccion?.moneda);

      if (deduccion.id == 0)
      {
        this.habilitarForm(true);
      }
      else
      {
        this.habilitarForm(false);
      }
      this.chequeoRetro();
    }
  }

  habilitarForm(habilitado: boolean)
  {
    if (this.form != undefined)
    {
      if (habilitado)
      {
        this.form.enable();
      }
      else
      {
        this.form.disable();
      }
      this.formHabilitado = habilitado;
      this.getTipoCargaCodigoNomina(this.deduccionIIGGForm.codigoNomina);
    }
  }

  ngAfterViewInit()
  {
    if (this.form.controls['id'].value != "0")
    {
      this.form.controls['importe'].setValue(this.deduccionIIGGForm?.importe);
      this.actualizarFormatoInputNumerico = true;
    }
  }

  onChangeCodigoNomina(event)
  {
    this.getTipoCargaCodigoNomina(event.value);
    if (this.tipoCarga == 2) 
    {
      this.form.controls['importe'].setValue(0);
      this.form.controls['moneda'].setValue(1);
    } else if (this.tipoCarga == 1)
    {
      this.form.controls['cantidad'].setValue(0);
    } else if (this.tipoCarga == 4)
    {
      this.form.controls['importe'].setValue(0);
      this.form.controls['moneda'].setValue(1);
      this.form.controls['cantidad'].setValue(0);
    }
  }

  getTipoCargaCodigoNomina(nomina:number){
    this.tipoCarga = 0;
    if (nomina != null) {
      this.tipoCarga = this.codigosNominaList.find(m => m.id == nomina).tipoCarga;
    }
    if (this.tipoCarga == 2) 
    {
      this.setValidatorRequired('importe', null);
      this.setValidatorRequired('moneda', null);
      this.setValidatorRequired('cantidad', Validators.required);
    } else if (this.tipoCarga == 1)
    {
      this.setValidatorRequired('importe', Validators.required);
      this.setValidatorRequired('moneda', Validators.required);
      this.setValidatorRequired('cantidad', null);
    } else if (this.tipoCarga == 3)
    {
      this.setValidatorRequired('importe', Validators.required);
      this.setValidatorRequired('cantidad', Validators.required);
      this.setValidatorRequired('moneda', Validators.required);
    } else
    {
      this.setValidatorRequired('importe', null);
      this.setValidatorRequired('moneda', null);
      this.setValidatorRequired('cantidad', null);
    }
  }

  setValidatorRequired(campo, requerido) {
    this.form.controls[campo].setValidators(requerido);
    this.form.controls[campo].updateValueAndValidity();
  }

  cargaConceptos()
  {
    //Carga los conceptos validos
    let desde = this.form.get("desde").value.toDateString();
    let hasta = this.form.get("hasta").value.toDateString();
    let concepto = this.form.get("codigoNomina").value;

    this.codigosNominaList = this.NominaList && this.NominaList.filter(items => items.deduccionesIIGG == true &&
                                                                                Date.parse(items.desde) <= Date.parse(hasta) &&
                                                                                Date.parse(items.hasta) >= Date.parse(desde)) ;
    
    let index = this.codigosNominaList.findIndex(x => x.id == concepto)
    if (index == -1)
    {
      //No existe en la nueva lista, lo limpio
      this.form.controls['codigoNomina'].setValue(null);
    }
  }

  onChangeFechas()
  {
    this.cargaConceptos();
    this.chequeoRetro();
  }

  chequeoRetro()
  {
    //Por el momento no chequea

    // this.MensajeRetro = "";
    // let desde = this.form.get("desde").value.toDateString();
    // let hasta = this.form.get("hasta").value.toDateString();
    
    // this.personalService.ChequeoRetroactividad(this.deduccionIIGGForm.personal, 'DeduccionesIIGG', desde, hasta, true).subscribe(
    //   data =>
    //   {
    //     let resul = data;
    //     if (resul.haceRetro)
    //     {
    //       let fecha = formatDate(resul.fechaRetro, 'dd-MM-yyyy', 'en-US');
    //       this.MensajeRetro = "Esta acción generará Retro a partir del " + fecha.toString();
    //     }
    //   }
    // );
  }
}

